import { background, brandPrimaryHover, brandSecondary, titles } from '../../../web/styles/colors';
import { CssSelectors, Layouts } from '../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	clearRenewalKeyFactsText: {
		color: titles,
		fontSize: 14,
		height: 20,
		paddingLeft: 10,
		width: 500,
	},
	container: {
		color: titles,
		fontSize: 14,
		padding: '30px 60px',
	},
	grayed: {
		cursor: 'not-allowed',
		opacity: 0.4,
		pointerEvents: 'none',
	},
	infoIcon: {
		marginLeft: 4,
		marginTop: 5,
	},
	infoMessage: {
		background,
		borderRadius: 3,
		boxShadow: '0 0 3px 1px rgba(0,0,0,0.1)',
		color: titles,
		fontSize: 12,
		maxWidth: 300,
		padding: 10,
		transform: 'translate3d(0,2px,0)',
	},
	nextButtonSection: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		margin: 30,
		...Layouts.horizontalStack(20),
	},
	processing: {
		marginTop: 40,
	},
	selectStepTitle: {
		alignItems: 'center',
		display: 'flex',
		width: 1000,
	},
	stepContent: {
		padding: '0px 30px',
	},
	stepSection: {
		margin: '10px 0',
	},
	stepTitle: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren({
			marginRight: 10,
		}),
		padding: '15px 0 5px',
		width: '100%',
	},
	title: {
		color: brandPrimaryHover,
		fontSize: 24,
	},
	topNextButton: {
		marginRight: 30,
	},
	uploadField: {
		background: '#F9F9F9',
		border: `1px dashed ${brandSecondary}`,
		borderRadius: 4,
		height: 300,
		position: 'relative',
	},
	uploadSpreadsheetIcon: {
		boxShadow: '0 1px 2px 0 rgba(0,0,0,0.20)',
	},
	uploadTarget: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
	uploadTargetOverlay: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		...CssSelectors.allChildren(
			{
				marginTop: 10,
			},
			':not(:first-child)'
		),
	},
	uploadTargetOverlayArrow: {
		display: 'block',
	},
	uploadTargetOverlayButton: {
		fontSize: 16,
	},
	uploadTargetOverlayChosenFile: {
		color: titles,
		fontSize: 18,
	},
	uploadTargetOverlayMessage: {
		color: '#858585',
		fontSize: 16,
	},
	userSelect: {
		margin: '0 10px',
		width: 200,
	},
});
